// extracted by mini-css-extract-plugin
module.exports = {"sides":"Layout_sides__19ylR","middle":"Layout_middle__wWeS9"};